import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Chip, Grid, Typography, Tabs, Tab, Box } from "@material-ui/core";
// import { runProps } from "./Runs";
import { useGetRuns } from "../../api/replenishmentApi";
import { longDateTimeFormat, formatDate } from "../../utils/dateUtil";
import RunProductsDataGrid from "../RunsDataGrid/RunProductsDataGrid";
import { GridExpandMoreIcon } from "@mui/x-data-grid-pro";
import { useRunsStyles } from "./RunsStyles";
import { runsProps } from "./Runs.d";
import { TabContext, TabPanel } from "@material-ui/lab";
import { Category, MoveDown } from "@mui/icons-material";
import TransfersDataGrid from "../TransfersDataGrid/TransfersDataGrid";


const Runs: React.FC<runsProps> = (props: runsProps) => {
	const {
		scheduleId
	} = props;

	const classes = useRunsStyles();
	const [ selectedTab, setSelectedTab ] = useState("items");

	const [{ data: runs, loading: loading }, getRuns] = useGetRuns(scheduleId);
	
	if(runs) {
		return (
			<Grid container spacing={2} sx={{border: '1px lightGrey', borderStyle: 'solid', paddingTop: 2, paddingBottom: 2}}>
				{runs.map((run, index) => {
					return(
						<Accordion key={`accordion-${index}`} className={classes.accordion}>
							<AccordionSummary
							expandIcon={<GridExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
							>
								<Grid container direction="row" spacing={2}>
									<Grid item>
										{run.dateCreated && <Typography>Created at: {formatDate(run.dateCreated, longDateTimeFormat)}</Typography>}
									</Grid>
									<Grid item>
										<Chip label={run.status}/>
									</Grid>
								</Grid>
						</AccordionSummary>
						<AccordionDetails>
						<Box sx={{ borderBottom: 1, borderColor: 'lightGrey' }}>
							<TabContext value={selectedTab}>
								<Box sx={{ borderBottom: 1, borderColor: 'lightGrey', minWidth: 1400 }}>
									<Tabs
										value={selectedTab}
										onChange={(e, value) => setSelectedTab(value)}
										aria-label="tabs"
										textColor="primary"
										indicatorColor="primary"
										variant="scrollable"
										>
										<Tab icon={<Category/>} label="Items" value="items"/>
										<Tab icon={<MoveDown />} label="Transfers" value="transfers"/>
									</Tabs>
								</Box>
								<TabPanel value="items">
									<RunProductsDataGrid products={run.products}/>
								</TabPanel>
								<TabPanel value="transfers">
									{run.transfers && <TransfersDataGrid transfers={run.transfers}/>}
								</TabPanel>
							</TabContext>
							</Box>
						</AccordionDetails>
					  </Accordion>
					)
				})}
			</Grid>
		);
	} else {
		return (<></>)
	}
};

export default Runs;
